import { SizeGuidesGridView } from '~/components/attributes/size-guides/grid';
import { PageContainer } from '~/components/page-container';

export function SizeGuides() {
	return (
		<PageContainer>
			<SizeGuidesGridView />
		</PageContainer>
	);
}
